export default "__VITE_ASSET__dywn7Kqe__"